import React from 'react';
import PropTypes from 'prop-types';
import TemplateList from '../../../components/templateList';

export default function OrgaTemplateList({ organization, partnerId }) {
    return <TemplateList organization={organization} partnerId={partnerId} />;
}

OrgaTemplateList.propTypes = {
    organization: PropTypes.object.isRequired,
    partnerId: PropTypes.string.isRequired
};
